import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import '../../../../assests/css/admin/AdminProfileSetting/AdminMyProfile/AdminMyProfile.css';

const AdminMyProfile = () => {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);

  const emptyProfile = {
    firstName: '', lastName: '', phone: '', businessName: '', email: '', profileImage: null
  };

  const [profileData, setProfileData] = useState(emptyProfile);
  const [editData, setEditData]       = useState(emptyProfile);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const token = localStorage.getItem('adminToken');
  const authHeaders = { headers: { Authorization: `Bearer ${token}` } };

  const mapProfile = (p, withImage = true) => ({
    firstName:    p.firstName    || '',
    lastName:     p.lastName     || '',
    phone:        p.phone        || '',
    businessName: p.businessName || '',
    email:        p.email        || '',
    profileImage: withImage && p.profileImage ? `${baseUrlForFiles}/${p.profileImage}` : null
  });

  // ── Profile load karo ──
  useEffect(() => {
    const loadProfile = async () => {
      try {
        const meRes = await axios.get(`${baseUrl}/admin/me`, authHeaders);
        if (!meRes.data.success) return;
        const admin = meRes.data.admin;

        const profileRes = await axios.get(`${baseUrl}/admin/view-adminprofile`, authHeaders);

        if (profileRes.data.success && profileRes.data.profileData) {
          const mapped = mapProfile(profileRes.data.profileData);
          setProfileData(mapped);
          setEditData(mapped);
        } else {
          const form = new FormData();
          form.append('firstName', admin.firstname || '');
          form.append('lastName',  admin.lastname  || '');
          form.append('email',     admin.email     || '');
          form.append('phone',     admin.phone     || '');
          form.append('existingProfileImage', admin.profile_image || ''); 

          const createRes = await axios.post(`${baseUrl}/admin/adminprofile`, form, authHeaders);
          if (createRes.data.success && createRes.data.profileData) {
            const mapped = mapProfile(createRes.data.profileData);
            setProfileData(mapped);
            setEditData(mapped);
          }
        }
      } catch (err) {
        console.error('Profile load failed:', err);
      }
    };

    loadProfile();
  }, []);


   const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setProfileData((prev) => ({ ...prev, profileImage: reader.result }));
    };
    reader.readAsDataURL(file);

    const form = new FormData();
    form.append('firstName',    profileData.firstName);
    form.append('lastName',     profileData.lastName);
    form.append('phone',        profileData.phone);
    form.append('businessName', profileData.businessName);
    form.append('email',        profileData.email);
    form.append('profileImage', file);

    axios.post(`${baseUrl}/admin/update-adminprofile`, form, authHeaders)
      .then((res) => {
        if (res.data.success) setMessage('Image updated!');
      })
      .catch(() => setMessage('Image upload failed. Please try again.'));
  };


  const handleEditClick = () => {
    setEditData(profileData);
    setIsEditModalOpen(true);
  };

  const handleCancel = () => {
    setEditData(profileData);
    setIsEditModalOpen(false);
  };

  const handleSave = () => {
    setLoading(true);
    const form = new FormData();
    form.append('firstName',    editData.firstName);
    form.append('lastName',     editData.lastName);
    form.append('phone',        editData.phone);
    form.append('businessName', editData.businessName);
    form.append('email',        editData.email);

    axios.post(`${baseUrl}/admin/update-adminprofile`, form, authHeaders)
      .then((res) => {
        if (res.data.success) {
          setProfileData(editData);
          setMessage('Profile updated successfully!');
        }
        setIsEditModalOpen(false);
      })
      .catch((err) => console.error('Update failed:', err))
      .finally(() => setLoading(false));
  };

  const getInitials = () =>
    `${profileData.firstName.charAt(0)}${profileData.lastName.charAt(0)}`;

  return (
    <div className="Admin-MyProfile-Manegement-admin-my-profile">

      {/* ── Header: avatar + naam + email ── */}
      <div className="Admin-MyProfile-Manegement-profile-header">
        <div className="Admin-MyProfile-Manegement-profile-avatar-container">
          <div className="Admin-MyProfile-Manegement-profile-avatar">
            {profileData.profileImage
              ? <img src={profileData.profileImage} alt="Profile" />
              : <span className="Admin-MyProfile-Manegement-avatar-initials">{getInitials()}</span>}
          </div>
          <label className="Admin-MyProfile-Manegement-avatar-upload-btn">
            <input type="file" accept="image/*" onChange={handleImageChange} style={{ display: 'none' }} />
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
              <circle cx="12" cy="13" r="4"/>
            </svg>
          </label>
        </div>
        <h1 className="Admin-MyProfile-Manegement-profile-name">
          {profileData.firstName} {profileData.lastName}
        </h1>
        <p className="Admin-MyProfile-Manegement-profile-email">{profileData.email}</p>
        {message && <p style={{ color: 'green', fontSize: '13px' }}>{message}</p>}
      </div>

      {/* ── Personal Information card ── */}
      <div className="Admin-MyProfile-Manegement-profile-info-card">
        <div className="Admin-MyProfile-Manegement-card-header">
          <h2>Personal Information</h2>
          <button className="Admin-MyProfile-Manegement-edit-btn" onClick={handleEditClick}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
            </svg>
            Edit
          </button>
        </div>

        <div className="Admin-MyProfile-Manegement-info-grid">
          <div className="Admin-MyProfile-Manegement-info-field">
            <label>First Name</label>
            <div className="Admin-MyProfile-Manegement-field-value">{profileData.firstName}</div>
          </div>
          <div className="Admin-MyProfile-Manegement-info-field">
            <label>Last Name</label>
            <div className="Admin-MyProfile-Manegement-field-value">{profileData.lastName}</div>
          </div>
        </div>

        <div className="Admin-MyProfile-Manegement-info-field">
          <label>Email Address</label>
          <div className="Admin-MyProfile-Manegement-field-value Admin-MyProfile-Manegement-email-value">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
              <polyline points="22,6 12,13 2,6"/>
            </svg>
            {profileData.email}
          </div>
        </div>

        <div className="Admin-MyProfile-Manegement-info-field">
          <label>Phone Number</label>
          <div className="Admin-MyProfile-Manegement-field-value Admin-MyProfile-Manegement-phone-value">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
            </svg>
            {profileData.phone}
          </div>
        </div>

        <div className="Admin-MyProfile-Manegement-info-field">
          <label>Business Name</label>
          <div className="Admin-MyProfile-Manegement-field-value Admin-MyProfile-Manegement-business-value">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
            </svg>
            {profileData.businessName}
          </div>
        </div>
      </div>

      {/* ── Edit modal ── */}
      {isEditModalOpen && (
        <div className="Admin-MyProfile-Manegement-modal-overlay" onClick={handleCancel}>
          <div className="Admin-MyProfile-Manegement-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="Admin-MyProfile-Manegement-modal-header">
              <h2>Edit Personal Information</h2>
              <button className="Admin-MyProfile-Manegement-close-btn" onClick={handleCancel}>×</button>
            </div>
            <div className="Admin-MyProfile-Manegement-modal-body">
              <div className="Admin-MyProfile-Manegement-form-grid">
                <div className="Admin-MyProfile-Manegement-form-group">
                  <label>First Name</label>
                  <input type="text" value={editData.firstName} onChange={(e) => setEditData({ ...editData, firstName: e.target.value })} />
                </div>
                <div className="Admin-MyProfile-Manegement-form-group">
                  <label>Last Name</label>
                  <input type="text" value={editData.lastName} onChange={(e) => setEditData({ ...editData, lastName: e.target.value })} />
                </div>
              </div>
              <div className="Admin-MyProfile-Manegement-form-group">
                <label>Email Address</label>
                <div className="Admin-MyProfile-Manegement-email-input-wrapper">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" className="Admin-MyProfile-Manegement-input-icon">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                  <input type="email" value={editData.email} onChange={(e) => setEditData({ ...editData, email: e.target.value })} placeholder="Enter email address" className="Admin-MyProfile-Manegement-input-with-icon" />
                </div>
              </div>
              <div className="Admin-MyProfile-Manegement-form-group">
                <label>Phone Number</label>
                <input type="tel" value={editData.phone} onChange={(e) => setEditData({ ...editData, phone: e.target.value })} />
              </div>
              <div className="Admin-MyProfile-Manegement-form-group">
                <label>Business Name</label>
                <input type="text" value={editData.businessName} onChange={(e) => setEditData({ ...editData, businessName: e.target.value })} />
              </div>
            </div>
            <div className="Admin-MyProfile-Manegement-modal-footer">
              <button className="Admin-MyProfile-Manegement-btn-cancel" onClick={handleCancel}>Cancel</button>
              <button className="Admin-MyProfile-Manegement-btn-save" onClick={handleSave} disabled={loading}>
                {loading ? 'Saving...' : 'Save Changes'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminMyProfile;